import KeyAssignmentExtendedMenu from './BCKeyAssignmentExtendedMenu.vue'
import KeyAssignmentMenu from './BCKeyAssignmentMenu.vue'
import KeyAssignmentSuperLock from './BCKeyAssignmentSuperLockSettings.vue'
import NetworkConfiguration from './BCNetworkConfigurationSettings.vue'
import NetworkWiFiManagementList from './BCNetworkWiFiManagementList.vue'
import NetworkWiFi from './BCNetworkWiFiSettings.vue'
import OptionalFeaturesPassword from './BCOptionalFeaturesPasswordSettings.vue'
import SelCallListSettings from './BCSelCallListSettings.vue'

export const componentsMap = {
  KeyAssignmentSuperLock,
  KeyAssignmentMenu,
  KeyAssignmentExtendedMenu,
  NetworkWiFi,
  NetworkWiFiManagementList,
  OptionalFeaturesPassword,
  SelCallStatusList: SelCallListSettings,
  SelCallMessageList: SelCallListSettings,
  NetworkConfiguration,
}
